// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconPrint: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="currentColor">
            <path
                d="M133.75,1085 L126.25,1085 C125.55957,1085 125,1085.56055 125,1086.25 L125,1088.125 C125,1088.47012 125.279883,1088.75 125.625,1088.75 L126.25,1088.75 L126.25,1090.625 C126.25,1090.97012 126.529883,1091.25 126.875,1091.25 L133.125,1091.25 C133.470117,1091.25 133.75,1090.97012 133.75,1090.625 L133.75,1088.75 L134.375,1088.75 C134.720117,1088.75 135,1088.47012 135,1088.125 L135,1086.25 C135,1085.56055 134.439453,1085 133.75,1085 Z M132.5,1090 L127.5,1090 L127.5,1088.125 L132.5,1088.125 L132.5,1090 Z M133.4375,1087.03125 C133.178711,1087.03125 132.96875,1086.82129 132.96875,1086.5625 C132.96875,1086.30332 133.178711,1086.09375 133.4375,1086.09375 C133.696289,1086.09375 133.90625,1086.30332 133.90625,1086.5625 C133.90625,1086.82227 133.697265,1087.03125 133.4375,1087.03125 Z M127.5,1082.5 L131.982422,1082.5 L132.5,1083.01777 L132.5,1084.375 L133.75,1084.375 L133.75,1082.75879 C133.75,1082.59309 133.684082,1082.43418 133.566895,1082.31699 L132.683105,1081.4332 C132.566406,1081.31592 132.40625,1081.25 132.242187,1081.25 L126.875,1081.25 C126.530078,1081.25 126.25,1081.52988 126.25,1081.875 L126.25,1084.375 L127.5,1084.375 L127.5,1082.5 Z"
                transform="translate(-125 -1081)"
            />
        </svg>
    );
};

export default React.memo(IconPrint);
